import { Button } from '@crm/ui';
import { Trash2, UserPlus } from 'lucide-react';
import { AccountRow } from './account-row';

export interface PickableAccount {
  id: string;
  name: string;
  email: string;
  role: string;
  conectada?: boolean;
}

interface AccountPickerProps {
  contas: PickableAccount[];
  onPick: (conta: PickableAccount) => void;
  onNova: () => void;
  /** Sem isto a conta nao pode ser tirada da lista. */
  onRemove?: (conta: PickableAccount) => void;
  vazio?: string;
}

/**
 * A lista de contas para escolher, com a porta para uma conta nova no fim.
 * Serve a tela de login e a troca de conta dentro do sistema.
 */
export function AccountPicker({ contas, onPick, onNova, onRemove, vazio }: AccountPickerProps) {
  return (
    <div className="divide-y divide-border">
      {contas.map((conta) => (
        <AccountRow
          key={conta.id}
          name={conta.name}
          email={conta.email}
          role={conta.role}
          conectada={conta.conectada}
          onClick={() => onPick(conta)}
          acao={
            onRemove ? (
              <Button
                variant="ghost"
                size="icon"
                aria-label={`Remover ${conta.name} da lista`}
                onClick={() => onRemove(conta)}
              >
                <Trash2 className="h-5 w-5 text-muted-foreground" />
              </Button>
            ) : null
          }
        />
      ))}

      {contas.length === 0 ? (
        <p className="px-4 py-8 text-center text-sm text-muted-foreground">
          {vazio ?? 'Nenhuma conta guardada neste navegador.'}
        </p>
      ) : null}

      <button
        type="button"
        onClick={onNova}
        className="flex w-full items-center gap-3 px-4 py-3 text-left text-sm transition-colors hover:bg-muted"
      >
        <UserPlus className="h-5 w-5 text-muted-foreground" />
        Entrar com outra conta
      </button>
    </div>
  );
}
